var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = __default(require("../../utils/helpers/partial.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"single-colorpicker",depth0,{"name":"partial","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":39}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});